export default "__VITE_ASSET__lYelTuSI__";